import { Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectUser } from "../../store/authSlice"
import { UpdateSize } from "../../utils/updateSize"
import { selectSize } from "../../store/handlingSlice"
import { MobileBar } from "./MobileBar"
import { Header } from "./Header"

import "./Layout.scss"

export function Layout() {
  const user = useSelector(selectUser)
  const size = useSelector(selectSize)

  return (
    <div className="Layout" data-mobile={size.mobile} >
      <UpdateSize />
      {!size.mobile && <Header user={user} />}
      <main className="main-content">
        <Outlet />
      </main>
      {size.mobile && <MobileBar />}
    </div>
  )
}
